import type { APIMenuItemType, UserMessageType } from '@/type/login';
import { isArray } from 'lodash';

enum ItemType {
    MENU = 1,
    PAGE,
}

export function userInfoTranslator(data: UserMessageType): UserInfoType {
    const menu: Record<string, any> = {};
    const page: Record<string, any> = {};

    function handleList(list: APIMenuItemType[], parentKeys: string[] = []) {
        const res: MenuItemType[] = [];
        list?.forEach((item) => {
            menu[item.path.split('?')[0]] = true;

            const temp: any = {
                path: item.path,
                name: item.name,
                hideInMenu: item.type === ItemType.PAGE,
                parentKeys,
            };
            if (isArray(item.childList) && item.childList.length > 0) {
                temp.children = handleList(
                    item.childList,
                    parentKeys.concat(item.path),
                );
            }
            res.push(temp);
        });
        return res;
    }

    // 处理 按钮权限
    const button =
        data?.pathList?.reduce((obj: Record<string, any>, key) => {
            obj[key] = true;
            return obj;
        }, {}) || {};

    return {
        id: data.id,
        userId: data.userId,
        userNo: data.userNo,
        name: data.name,
        jobNumber: data.jobNumber,
        gender: data.gender,
        mobile: data.mobile,
        email: data.email,
        menuData: handleList(data.menuList),
        access: { menu, page, button },
        deptFullName: data.deptFullName,
        deptId: data.deptId,
        deptName: data.deptName,
        autoReceiveStatus: data.autoReceiveStatus,
    };
}
